import Lenis from 'lenis';

export const smoothScroll = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return null;
  }

  const lenis = new Lenis({
    duration: 1.1,
    smoothWheel: true,
    autoRaf: false,
  });

  let rafId = null;

  const raf = (time) => {
    lenis.raf(time);
    rafId = window.requestAnimationFrame(raf);
  };

  rafId = window.requestAnimationFrame(raf);

  window.addEventListener('beforeunload', () => {
    if (rafId) {
      window.cancelAnimationFrame(rafId);
    }

    lenis.destroy();
  });

  return lenis;
};